import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPaperPlane, FaUser, FaHeading, FaCommentAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { MdEmail, MdPhone } from 'react-icons/md';

const HomeContactForm = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const formDataToSubmit = {
                ...formData,
                _subject: `New Contact Message: ${formData.subject}`,
                _template: 'table',
                _captcha: 'false'
            };

            const response = await fetch("https://formsubmit.co/ajax/choundeshwaripatasanstha@gmail.com", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(formDataToSubmit)
            });

            if (response.ok) {
                setSubmitStatus('success');
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
            } else {
                setSubmitStatus('error');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <span className="text-secondary font-bold tracking-widest uppercase text-sm mb-2 block">{t('contact.badge')}</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{t('contact.form.title')}</h2>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-gray-600 max-w-2xl mx-auto">{t('contact.form.description')}</p>
                </div>

                <form onSubmit={handleFormSubmit} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100">
                    <div className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                    <FaUser className="text-secondary" /> {t('contact.form.name')} *
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder={t('contact.form.namePlaceholder')}
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                    <MdPhone className="text-secondary" /> {t('contact.form.phone')} *
                                </label>
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder={t('contact.form.phonePlaceholder')}
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all outline-none"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                <MdEmail className="text-secondary" /> {t('contact.form.email')} *
                            </label>
                            <input
                                type="email"
                                name="email"
                                placeholder={t('contact.form.emailPlaceholder')}
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                <FaHeading className="text-secondary" /> {t('contact.form.subject')} *
                            </label>
                            <input
                                type="text"
                                name="subject"
                                placeholder={t('contact.form.subjectPlaceholder')}
                                value={formData.subject}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                <FaCommentAlt className="text-secondary" /> {t('contact.form.message')}
                            </label>
                            <textarea
                                name="message"
                                placeholder={t('contact.form.messagePlaceholder')}
                                value={formData.message}
                                onChange={handleChange}
                                rows="4"
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all outline-none resize-none"
                            ></textarea>
                        </div>

                        {/* Status Messages */}
                        {submitStatus === 'success' && (
                            <div className="bg-green-50 text-green-700 px-4 py-3 rounded-lg text-sm flex items-center gap-2 animate-fade-in">
                                <FaCheckCircle /> {t('contact.form.success')}
                            </div>
                        )}
                        {submitStatus === 'error' && (
                            <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm flex items-center gap-2 animate-fade-in">
                                <FaTimesCircle /> {t('contact.form.error')}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`w-full bg-primary hover:bg-primary-dark text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                        >
                            {isSubmitting ? (
                                <>
                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    {t('contact.form.sending')}
                                </>
                            ) : (
                                <>
                                    <FaPaperPlane /> {t('contact.form.submit')}
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default HomeContactForm;
